import React from 'react'
import { CCardBody } from '@coreui/react-pro'
import { useAllTransactionList } from './hooks'
import { TransactionsDetails } from '../atoms/TransactionsDetails/component'

export const AllTransactionList: React.FC = () => {
  const { currencies } = useAllTransactionList()

  return (
    <CCardBody>
      <TransactionsDetails allCurrencies={currencies} />
    </CCardBody>
  )
}
